// extracted by mini-css-extract-plugin
export default {"pdfViewer":"PdfViewer_pdfViewer__eaC2P"};